<template>
  <div>
    <b-card title="Crear Horario">
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row></b-row>
          <b-row>
            <b-col cols="1"></b-col>
            <b-col>
              <validation-provider
                #default="{ errors }"
                name="Nombre"
                rules="required">
                <b-form-group label-for="input-default">
                  <h4>Nombre</h4>
                  <b-form-input
                    id="input-default"
                    v-model="body.name"
                    :plaintext="togglePlaintext"
                    :state="errors.length > 0 ? false : null" />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="1"></b-col>
            <b-col>
              <validation-provider
                #default="{ errors }"
                name="Descripción"
                rules="required">
                <b-form-group label-for="input-default">
                  <h4>Descripción</h4>
                  <b-form-input
                    id="input-default"
                    v-model="body.description"
                    :plaintext="togglePlaintext"
                    :state="errors.length > 0 ? false : null" />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>

          <b-row>
            <b-col cols="1"></b-col>
            <b-col>
              <validation-provider
                #default="{ errors }"
                name="Fecha Inicio"
                rules="required">
                <b-form-group :state="errors.length > 0 ? false : null">
                  <h4>Fecha Inicio</h4>
                  <flat-pickr
                    :disabled="disable"
                    v-model="body.datetime_start"
                    :state="errors.length > 0 ? false : null"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      defaultDate: body.datetime_start,
                      time_24hr: true,
                      locale: {
                        firstDayOfWeek: 1,
                      },
                    }" />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="1"></b-col>
            <b-col>
              <validation-provider
                #default="{ errors }"
                name="Fecha Final"
                rules="required">
                <b-form-group :state="errors.length > 0 ? false : null">
                  <h4>Fecha Final</h4>
                  <flat-pickr
                    :disabled="disable"
                    v-model="body.datetime_end"
                    :state="errors.length > 0 ? false : null"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      defaultDate: body.datetime_end,
                      time_24hr: true,
                      locale: {
                        firstDayOfWeek: 1,
                      },
                    }" />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <b-row></b-row>
      <b-row>
        <b-col></b-col>
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          @click.prevent="validationForm"
          :hidden="hiddenComponent">
          <feather-icon icon="UploadIcon" class="mr-0 mr-sm-50"></feather-icon>
          Crear Horario
        </b-button>
        <b-button
          variant="outline-primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          to="/schedules">
          <feather-icon
            icon="ArrowLeftCircleIcon"
            class="mr-0 mr-sm-50"></feather-icon>
          Volver Atrás
        </b-button>
        <b-col></b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BInputGroup,
  BRow,
  BCol,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { ref } from "@vue/composition-api";
import axios from "@/libs/axios";
import { decryptString } from "@/libs/crypto";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BCard,
    BCardText,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BInputGroup,
    BRow,
    BCol,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.message();
        }
      });
    },
    async message() {
      const error = await this.onSubmit();
      if (error[0]) {
        const variant = "danger";
        this.$bvToast.toast("" + error[1], {
          title: "Failed",
          variant,
          solid: true,
        });
      } else if (!error[0]) {
        this.togglePlaintext = true;
        this.disable = true;
        this.hiddenComponent = true;
        const variant = "success";
        this.$bvToast.toast("Horario creado correctamente", {
          title: `Create`,
          variant,
          solid: true,
        });
      }
    },
  },
  data() {
    return {
      required,
      disable: false,
      hiddenComponent: false,
      togglePlaintext: false,
    };
  },
  setup() {
    const blankTimetableData = {
      name: "",
      description: "",
      datetime_start: "",
      datetime_end: "",
      IdUser: decryptString(localStorage.getItem("idUser")),
    };

    const body = ref(JSON.parse(JSON.stringify(blankTimetableData)));

    const onSubmit = async () => {
      const onError = [false, ""];
      await axios
        .post("/addTimetable", body.value)
        .then((result) => {
          onError[0] = false;
        })
        .catch((error) => {
          onError[0] = true;
          onError[1] = error;
        });
      return onError;
    };

    return {
      body,
      onSubmit,
    };
  },
  mounted() {
    if (localStorage.getItem("accessToken") === null) {
      this.$router.go(0);
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.row {
  padding-top: 0.5%;
  padding-bottom: 0.5%;
}
</style>
